import {
  STAT_BEST_SELLERS,
  STAT_CANCELLATION_RATE,
  STAT_AVG_TIME_TO_SHIP,
  STAT_SHIP_ON_TIME_RATE,
  STAT_GMV,
  STAT_AOV,
  STAT_IPT,
} from '../../constants/stats';
import { SUPPLIER_STATS_DATA, SUPPLIER_STATS_LOADING, SUPPLIER_STATS_RETAILERS } from '../constants/statsTypes';

const initialState = {
  data: {
    [STAT_BEST_SELLERS]: [],
    [STAT_CANCELLATION_RATE]: [],
    [STAT_AVG_TIME_TO_SHIP]: [],
    [STAT_SHIP_ON_TIME_RATE]: [],
    [STAT_GMV]: [],
    [STAT_AOV]: [],
    [STAT_IPT]: [],
  },
  isLoading: true,
  retailers: [],
};

const supplierStats = (state = initialState, action) => {
  switch (action.type) {
    case SUPPLIER_STATS_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
        isLoading: false,
      };

    case SUPPLIER_STATS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case SUPPLIER_STATS_RETAILERS:
      return {
        ...state,
        retailers: action.payload,
      };

    default:
      break;
  }
  return state;
};

export default supplierStats;
